module.exports = __webpack_public_path__ + "img/big_bar_bg.ddd19cb5.png";